import { render, staticRenderFns } from "./ProcesoPreguntas.vue?vue&type=template&id=39bc4026&"
import script from "./ProcesoPreguntas.vue?vue&type=script&lang=js&"
export * from "./ProcesoPreguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports